import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErroRoutingModule } from './erro-routing.module';
import { ErroPageComponent } from './pages/erro-page/erro-page.component';


@NgModule({
  declarations: [
    ErroPageComponent
  ],
  imports: [
    CommonModule,
    ErroRoutingModule
  ]
})
export class ErroModule { }
